import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const contractsOwnerTypesAdapter = getAdapter({ idFieldName: 'value' });

const contractsOwnerTypesSlice = createSlice({
  name: 'contractsOwnerTypes',
  initialState: contractsOwnerTypesAdapter.getInitialState(),
  reducers: {
    setContractsOwnerTypes: (state, { payload: { contractsOwnerTypes } }) => {
      contractsOwnerTypesAdapter.setAll(state, contractsOwnerTypes);
    }
  }
});

const selectors = contractsOwnerTypesAdapter.getSelectors(({ contractsOwnerTypes }) => contractsOwnerTypes);

export const getContractsOwnerTypes = state => selectors.selectAll(state);


export const { setContractsOwnerTypes } = contractsOwnerTypesSlice.actions;

export default contractsOwnerTypesSlice.reducer;
